import React, { useEffect} from 'react';
import AccountMenuDesktop from './navbarWebLogged';
import AccountMenuMobile from './navbarMobileLogged';

const Converter = () => {

  // Changing which menu to be shown depending on Mobile or Desktop screen
    const [width, setWidth] = React.useState(window.innerWidth);
    const breakPoint = 860;
  
    useEffect(() => {
     const handleWindowResize = () => setWidth(window.innerWidth);
     window.addEventListener("resize", handleWindowResize);
  
     return () => window.removeEventListener("resize", handleWindowResize);
    },[]);
  
    return (
      <div>
        {width > breakPoint? (
         <AccountMenuDesktop/>
        ) : (
         <AccountMenuMobile/>
        )}
      </div>
    );
  }

  export default Converter;